import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Safely access environment variables
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

// Log environment info in development only
if (process.env.NODE_ENV !== 'production') {
  console.log('Environment:', process.env.NODE_ENV);
  console.log('API URL:', API_URL);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 